// extracted by mini-css-extract-plugin
export var avatar = "_pa-3";
export var avatarContainer = "_pa-2";
export var avatarSpacer = "_pa-5";
export var avatarSpacerContainer = "_pa-4";
export var avatarStackContainer = "_pa-1";
export var bubble = "_pa-0";
export var remainderBubble = "_pa-6";